import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserDashboardComponent } from './user/user-dashboard/user-dashboard.component';
import { LoginComponent } from './auth/components/login/login.component';
import { RegisterComponent } from './auth/components/register/register.component';
import { ForgotPasswordComponent } from './auth/components/forgot-password/forgot-password.component';
import { BasicCalculatorComponent } from './user/calculators/basic-calculator/basic-calculator.component';
import { HolidayCalculatorComponent } from './user/calculators/holiday-calculator/holiday-calculator.component';
import { PlaneCalculatorComponent } from './user/calculators/plane-calculator/plane-calculator.component';
import { FileImportCalculatorComponent } from './user/calculators/file-import-calculator/file-import-calculator.component';
import { EventCalculatorComponent } from './user/calculators/event-calculator/event-calculator.component';
import { IntegrationComponent } from './user/calculators/integration/integration.component';
import { OrdersComponent } from './user/calculators/orders/orders.component';
import { ContactComponent } from './user/calculators/contact/contact.component';
import { CalculatorsPageComponent } from './pages/calculators/calculators-page.component';
import { AccountMenuComponent } from './user/account/account-menu/account-menu.component';
import { BoardComponent } from './travel-board/components/board/board.component';
import { DashboardComponent } from './impact/components/dashboard/dashboard.component';
import { MenuComponent } from './user/menu/menu.component';
// import { CalculatorListComponent } from './user/calculators/calculator-list/calculator-list.component';
import { ResourcesPageComponent } from './resources/resources-page/resources-page.component';
import { ClimatePartnerComponent } from './resources/climate-partner/climate-partner.component';
import { ClimateProjectsComponent } from './resources/climate-projects/climate-projects.component';
import { ClimateInitiativesComponent } from './resources/climate-initiatives/climate-initiatives.component';
import { authGuard } from './auth/auth.guard';
import { LoginPageComponent } from './auth/components/login-page/login-page.component';
import { ResetPasswordComponent } from './auth/components/reset-password/reset-password.component';
import { EmailVerificationPendingComponent } from './auth/components/email-verification-pending/email-verification-pending.component';
import { VerifyEmailComponent } from './auth/components/verify-email/verify-email.component';
import { AccessRequestSentComponent } from './auth/components/access-request-sent/access-request-sent.component';
import { AdminPageComponent } from './admin/components/admin-page/admin-page.component';
import { superAdminGuard } from './admin/auth/super-admin.guard';
import { ManageCompaniesComponent } from './admin/components/manage-companies/manage-companies.component';
import { EditCompanyComponent } from './admin/components/edit-company/edit-company.component';
import { EditUserComponent } from './admin/components/edit-user/edit-user.component';
import { ManageUsersComponent } from './admin/components/manage-users/manage-users.component';
import { ListProjectsComponent } from './admin/components/list-projects/list-projects.component';
import { EditProjectComponent } from './admin/components/edit-project/edit-project.component';
import { ListContributionsComponent } from './admin/components/list-contributions/list-contributions.component';
import { ContributionDetailComponent } from './admin/components/contribution-detail/contribution-detail.component';
import { ListDocumentJobsComponent } from './admin/components/list-document-jobs/list-document-jobs.component';
import { DocumentJobDetailComponent } from './admin/components/document-job-detail/document-job-detail.component';
import { MailingListComponent } from './admin/components/mailing-list/mailing-list.component';
import { ClientsPageComponent } from './pages/clients/clients-page.component';
import { ContributionListComponent } from './pages/contributions/contribution-list/contribution-list.component';
import { UserContributionDetailComponent } from './pages/contributions/contribution-detail/contribution-detail.component';
import { HelpPageComponent } from './pages/help/help-page.component';
import { HelpSupportComponent } from './pages/help/help-support/help-support.component';
import { HelpOnboardingComponent } from './pages/help/help-onboarding/help-onboarding.component';
import { HelpResourcesComponent } from './pages/help/help-resources/help-resources.component';
import { HelpHowItWorksComponent } from './pages/help/help-how-it-works/help-how-it-works.component';
import { UserInformationsComponent } from './user/account/user-informations/user-informations.component';
import { CompanyInformationsComponent } from './user/account/company-informations/company-informations.component';
import { BillingComponent } from './user/account/billing/billing.component';
import { ManageCompanyUsersComponent } from './user/account/manage-company-users/manage-company-users.component';
import { TripImpactPageComponent } from './impact/components/trip-impact-page/trip-impact-page.component';
import { TripDashboardComponent } from './trip-calculator/components/trip-dashboard/trip-dashboard.component';
import { ContributePageComponent } from './pages/contribute/contribute-page.component';
import { ManagePacksComponent } from './admin/components/manage-packs/manage-packs.component';
import { EditPackComponent } from './admin/components/edit-pack/edit-pack.component';
import { ClientFilterGuard } from './guards/filter-client.guard';
import { StatisticsPageComponent } from './admin/components/statistics-page/statistics-page.component';
import { ManageFactorsComponent } from './admin/components/manage-factors/manage-factors.component';
import { ManageSubscriptionComponent } from './shared/components/manage-subscription/manage-subscription.component';
import { ObjectivesPageComponent } from './pages/objectives/objectives-page.component';
import { ManageFactorPageComponent } from './factors/components/manage-factor-page/manage-factor-page.component';
import { UpdateNotesPageComponent } from './update-notes/components/update-notes-page/update-notes-page.component';
import { ManageUpdateNotesComponent } from './admin/components/manage-update-notes/manage-update-notes.component';
import { EditUpdateNoteComponent } from './admin/components/edit-update-note/edit-update-note.component';

const routes: Routes = [
  {
    path: 'home',
    component: MenuComponent,
    canActivate: [authGuard],
    children: [
      /************************
       * Main navigation pages *
       ************************/
      { path: '', redirectTo: 'travel-board', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'dashboard-temp', component: DashboardComponent },
      { path: 'travel-board', component: BoardComponent },
      {
        path: 'clients',
        component: ClientsPageComponent,
        canActivate: [ClientFilterGuard],
      },
      {
        path: 'contributions',
        component: ContributionListComponent,
        canActivate: [superAdminGuard],
      },
      {
        path: 'contributions/:id',
        component: UserContributionDetailComponent,
        canActivate: [superAdminGuard],
      },
      { path: 'calculators', component: CalculatorsPageComponent },
      { path: 'objectives', component: ObjectivesPageComponent },
      { path: 'factors', component: ManageFactorPageComponent },
      { path: 'updates', component: UpdateNotesPageComponent },

      {
        path: 'help',
        component: HelpPageComponent,
        children: [
          { path: '', redirectTo: 'onboarding', pathMatch: 'full' },
          { path: 'support', component: HelpSupportComponent },
          { path: 'onboarding', component: HelpOnboardingComponent },
          { path: 'resources', component: HelpResourcesComponent },
          { path: 'how-it-works', component: HelpHowItWorksComponent },
        ],
      },
      { path: 'select-pack', component: ManageSubscriptionComponent },

      /*******************
       * Trips Routes    *
       *******************/
      { path: 'trips/:id/dashboard', component: TripDashboardComponent },
      {
        path: 'trips/:tripId/contribute',
        component: ContributePageComponent,
        canActivate: [superAdminGuard],
      },

      /************************
       * Legacy routes        *
       ************************/
      { path: 'impact-panel', redirectTo: 'travel-board', pathMatch: 'full' }, // Legacy redirect
      { path: 'user', component: UserDashboardComponent }, // Keep for compatibility

      /************************
       * Resources *
       ************************/
      { path: 'resources', component: ResourcesPageComponent },
      { path: 'ressources', redirectTo: 'resources', pathMatch: 'full' }, // Fix typo
      {
        path: 'resources/climate-partner',
        component: ClimatePartnerComponent,
      },
      {
        path: 'resources/climate-projects',
        component: ClimateProjectsComponent,
      },
      {
        path: 'resources/climate-initiatives',
        component: ClimateInitiativesComponent,
      },
      // Legacy resource routes with typo
      {
        path: 'ressources/climate-partner',
        component: ClimatePartnerComponent,
      },
      {
        path: 'ressources/climate-projects',
        component: ClimateProjectsComponent,
      },
      {
        path: 'ressources/climate-initiatives',
        component: ClimateInitiativesComponent,
      },

      /************************
       * Calculator routes *
       ************************/
      {
        path: 'basic-calculator',
        component: BasicCalculatorComponent,
      },
      {
        path: 'holiday-calculator',
        component: HolidayCalculatorComponent,
      },
      {
        path: 'plane-calculator',
        component: PlaneCalculatorComponent,
      },
      {
        path: 'file-import-calculator',
        component: FileImportCalculatorComponent,
      },
      {
        path: 'event-calculator',
        component: EventCalculatorComponent,
      },
      { path: 'integration', component: IntegrationComponent },
      { path: 'orders', component: OrdersComponent },
      { path: 'contact', component: ContactComponent },

      /********************
       * Account *
       ********************/
      {
        path: 'account',
        component: AccountMenuComponent,
        children: [
          { path: 'profile', component: UserInformationsComponent },
          { path: 'company', component: CompanyInformationsComponent },
          { path: 'users', component: ManageCompanyUsersComponent },
          { path: 'billing', component: BillingComponent },
          { path: '', redirectTo: 'profile', pathMatch: 'full' },
          { path: '**', redirectTo: 'profile' },
        ],
      },
      // { path: 'impact-report/:id', component: ImpactReportComponent }, // Deprecated - use trips/:id/impact instead
      { path: 'trips/:id/impact', component: TripImpactPageComponent },
    ],
  },

  {
    path: 'auth',
    component: LoginPageComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      {
        path: 'email-verification-pending',
        component: EmailVerificationPendingComponent,
      },
      { path: 'verify-email', component: VerifyEmailComponent },
      { path: 'access-request-sent', component: AccessRequestSentComponent },
    ],
  },
  {
    path: 'admin',
    component: AdminPageComponent,
    canActivate: [superAdminGuard],
    children: [
      { path: 'company', component: ManageCompaniesComponent },
      { path: 'company/edit/:id', component: EditCompanyComponent },
      { path: 'company/create', component: EditCompanyComponent },
      { path: 'user', component: ManageUsersComponent },
      { path: 'user/edit/:id', component: EditUserComponent },
      { path: 'user/create', component: EditUserComponent },
      { path: 'projects', component: ListProjectsComponent },
      { path: 'projects/new', component: EditProjectComponent },
      { path: 'projects/edit/:id', component: EditProjectComponent },
      { path: 'contributions', component: ListContributionsComponent },
      { path: 'contributions/:id', component: ContributionDetailComponent },
      { path: 'document-jobs', component: ListDocumentJobsComponent },
      { path: 'document-jobs/:id', component: DocumentJobDetailComponent },
      { path: 'mailing-list', component: MailingListComponent },
      { path: 'pack', component: ManagePacksComponent },
      { path: 'pack/edit/:id', component: EditPackComponent },
      { path: 'pack/create', component: EditPackComponent },
      { path: 'statistics', component: StatisticsPageComponent },
      { path: 'factors', component: ManageFactorsComponent },
      { path: 'update-notes', component: ManageUpdateNotesComponent },
      { path: 'update-notes/create', component: EditUpdateNoteComponent },
      { path: 'update-notes/edit/:id', component: EditUpdateNoteComponent },
      { path: '', redirectTo: 'company', pathMatch: 'full' },
      { path: '**', redirectTo: 'company' },
    ],
  },
  { path: '', redirectTo: 'home/travel-board', pathMatch: 'full' }, // redirect to `travel-board` path by default
  { path: '**', redirectTo: 'home/travel-board' }, // fallback route
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
